import React from 'react'

const PageNotfound = () => {
  return (
    <div className='continer d-flex align-items-center' style={{ height: "100vh" }}>
        <div className='section mx-auto' style={{ backgroundColor: '#a6191f', width: '50%', height: '50%', borderRadius: '10px'}}>
            <h1 className='text-center text-light display-1 pt-5'>
                404
            </h1>
            <h3 className='text-center text-light'>
                Page Not Found
            </h3>
        </div>
    </div>
  )
}

export default PageNotfound